// Static content for the About Us page.
// Kept as plain data (instead of PageBuilder / hosted assets) so the page
// no longer depends on a fetched "about-us" page asset.

export const companyInfo = {
  name: 'Metta People Ltd. (Thailand)',
  effectiveDate: 'July 2026',
};

// Block types used below:
// p            -> paragraph, { id }
// attribution  -> italic signature line, { id }
// box          -> bordered sub-section box (titleId + bodyId)

export const aboutSections = [
  {
    titleId: 'AboutUsPage.s1.title',
    accentBar: true,
    blocks: [
      { type: 'p', id: 'AboutUsPage.s1.b1' },
      { type: 'p', id: 'AboutUsPage.s1.b2' },
      { type: 'p', id: 'AboutUsPage.s1.b3' },
      { type: 'p', id: 'AboutUsPage.s1.b4' },
      { type: 'p', id: 'AboutUsPage.s1.b5' },
      { type: 'attribution', id: 'AboutUsPage.s1.attribution' },
    ],
  },
  {
    titleId: 'AboutUsPage.s2.title',
    gradient: true,
    blocks: [
      {
        type: 'box',
        titleId: 'AboutUsPage.s2.box1.title',
        bodyId: 'AboutUsPage.s2.box1.body',
      },
      {
        type: 'box',
        titleId: 'AboutUsPage.s2.box2.title',
        bodyId: 'AboutUsPage.s2.box2.body',
      },
      {
        type: 'box',
        titleId: 'AboutUsPage.s2.box3.title',
        bodyId: 'AboutUsPage.s2.box3.body',
      },
    ],
  },
  {
    titleId: 'AboutUsPage.s3.title',
    accentBar: true,
    blocks: [
      {
        type: 'box',
        titleId: 'AboutUsPage.s3.box1.title',
        bodyId: 'AboutUsPage.s3.box1.body',
      },
      {
        type: 'box',
        titleId: 'AboutUsPage.s3.box2.title',
        bodyId: 'AboutUsPage.s3.box2.body',
      },
      {
        type: 'box',
        titleId: 'AboutUsPage.s3.box3.title',
        bodyId: 'AboutUsPage.s3.box3.body',
      },
    ],
  },
  {
    titleId: 'AboutUsPage.s4.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'AboutUsPage.s4.b1' }],
  },
];
